import { ADD_DEPARTMENT, DELETE_DEPARTMENT, REFRESH_DEPARTMENTS, UPDATE_DEPARTMENT } from "../actions/department.action";

const initialState = {
  departments: [],
  lastLoadedCompanyId: null,
};

// Helper function to sort departments by name
const sortDepartmentsByName = (departments) => {
  return [...departments].sort((a, b) => {
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_DEPARTMENTS:
      return {
        ...state,
        departments: sortDepartmentsByName(action.departments),
        lastLoadedCompanyId: action.companyId || null,
      };
    case ADD_DEPARTMENT:
      return {
        ...state,
        departments: sortDepartmentsByName([...state.departments, action.department]),
      };
    case UPDATE_DEPARTMENT:
      const updatedDepartments = state.departments.map((department) =>
        department.id === action.department.id ? action.department : department
      );
      return {
        ...state,
        departments: sortDepartmentsByName(updatedDepartments),
      };
    case DELETE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.filter((department) => department.id !== action.departmentId),
      };
    default:
      return state;
      
  }
};

export default departmentReducer;
